import { render, staticRenderFns } from "./GroupAssignment.vue?vue&type=template&id=0966007c&scoped=true"
import script from "./GroupAssignment.vue?vue&type=script&lang=ts"
export * from "./GroupAssignment.vue?vue&type=script&lang=ts"
import style0 from "./GroupAssignment.vue?vue&type=style&index=0&id=0966007c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0966007c",
  null
  
)

export default component.exports